import { Modal } from "react-bootstrap";
import React, { useState } from "react";
import { BsPlus, BsDash } from "react-icons/bs";
import { DatePicker } from "rsuite";

const styles = `
.stock-modal-box {
 padding: 32px 30px 28px 30px;
}
.stock-modal-title { font-size: 1.22rem; font-weight: 600; }
.stock-modal-stock { color: #888; font-size: .97rem; font-weight: 500; margin-bottom: 20px; }
.stock-modal-row { display: flex; gap:15px; margin-bottom:28px; }
.stock-modal-toggle { flex:1; background: #fff; border:2px solid #ddd; border-radius:8px; padding: 18px 0 15px 0; cursor: pointer; display: flex; flex-direction:column; align-items:center; transition: border .15s; font-size: 1.04rem; font-weight: 500;}
.stock-modal-toggle.selected { border: 2px solid #222; box-shadow: 0 2px 8px #eee; }
.stock-modal-toggle svg {margin-bottom: 6px; font-size: 1.24rem;}
.stock-modal-label {font-size:.97rem; font-weight:500; margin:5px 0;}
.stock-modal-input, .stock-modal-textarea { width:100%; border-radius:6px; border:1px solid #d2d3d7; padding:9px 12px; font-size:1rem; margin-bottom:15px; outline:none;}
.stock-modal-input:focus, .stock-modal-textarea:focus {border:1.2px solid #999;}
.stock-modal-actions { display: flex; gap:7px; justify-content: flex-end; align-items:center; margin-top:15px;}
.stock-modal-btn-cancel { padding: 8px 15px; font-size: 1rem; border-radius:7px; font-weight:500; border:none; background:none; color:#222; cursor:pointer; transition: background .13s;}
.stock-modal-btn-cancel:hover {background: #f3f3f3;}
.stock-modal-btn-update { padding: 8px 20px; font-size:1rem; border-radius:7px; font-weight:500; border:none; background:#555; color:#fff; opacity:0.8; cursor:not-allowed; }
.stock-modal-close { position:absolute; top:16px; right:19px; font-size:1.2rem; border:none; background:none; color:#333; cursor:pointer; transition:color .13s; }
.stock-modal-close:hover {color:#c22;}
.stock-modal-datepicker { display:flex; align-items:center; gap:7px; }
.stock-modal-datepicker-icon { font-size:1.21rem; color:#aaa; margin-top:-1.5px; }
`;

export default function UpdateStockModal({ open, onClose }) {
  const [mode, setMode] = useState("add"); // "add" | "remove"
  const [quantity, setQuantity] = useState("");
  const [batch, setBatch] = useState("");
  const [expiry, setExpiry] = useState("");
  const [notes, setNotes] = useState("");

  return (
    <>
      <style>{styles}</style>
      <Modal
       show={open}             // use show instead of isOpen
        onHide={onClose}        // use onHide instead of onRequestClose
        centered
        style={{
          overlay: {
            backgroundColor: "rgba(0,0,0,0.23)",
            zIndex: 1001,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          content: {
            position: 'static',
            border: 'none',
            background: 'none',
            inset: 'auto',
            padding: 0
          }
        }}
      >
        <div className="stock-modal-box">
          <button className="stock-modal-close" aria-label="Close" onClick={onClose}>
            &times;
          </button>
          <div className="stock-modal-title">Update Stock: Amoxicillin 500mg</div>
          <div className="stock-modal-stock">Current stock: 1250 units</div>

          <div className="stock-modal-row">
            <div
              className={`stock-modal-toggle${mode === "add" ? " selected" : ""}`}
              onClick={() => setMode("add")}
            >
              <BsPlus />
              Add Stock
            </div>
            <div
              className={`stock-modal-toggle${mode === "remove" ? " selected" : ""}`}
              onClick={() => setMode("remove")}
            >
              <BsDash />
              Remove Stock
            </div>
          </div>

          <form>
            <div className="stock-modal-label">Quantity</div>
            <input
              className="stock-modal-input"
              type="number"
              min="0"
              value={quantity}
              onChange={e => setQuantity(e.target.value)}
              placeholder=""
            />

            {mode === "add" && (
              <>
                <div className="stock-modal-label">Batch Number</div>
                <input
                  className="stock-modal-input"
                  type="text"
                  value={batch}
                  onChange={e => setBatch(e.target.value)}
                  placeholder=""
                />

                <div className="stock-modal-label">Expiry Date</div>
      <div className="stock-modal-datepicker">
        <DatePicker
          value={expiry}
          onChange={setExpiry}
          format="dd-MMM-yyyy"         // ✅ shows like 12-Sep-2025
          placeholder="dd-mmm-yyyy"
          oneTap
          
          style={{ marginBottom: 0, width: "100%" }}
        />
      </div>
              </>
            )}

            <div className="stock-modal-label">Notes</div>
            <textarea
              className="stock-modal-textarea"
              rows={3}
              value={notes}
              onChange={e => setNotes(e.target.value)}
              placeholder="Add any additional information"
              style={{resize:"none"}}
            />
          </form>
          <div className="stock-modal-actions">
            <button className="stock-modal-btn-cancel" type="button" onClick={onClose}>Cancel</button>
            <button className="stock-modal-btn-update" type="button">Update Stock</button>
          </div>
        </div>
      </Modal>
    </>
  );
}
